import React from "react";
import styled from "styled-components";

const StyledDropdownListContainer = styled.ul`
  position: absolute;
  list-style: none;
  background: white;
  box-shadow: ${(props) => props.theme.shadow.lg};
  padding: 0.3rem 0.5rem;
  width: 7.5rem;
  right: 0;
  min-width: 100%;
  max-height: 17rem;
  overflow: auto;
  z-index: 10;
`;

export const DropdownListContainer = React.forwardRef(
  ({ options = [], renderItem, onSelect }, ref) => {
    return (
      <StyledDropdownListContainer ref={ref}>
        {options.map((option, i) => (
          <StyledDropdownItem key={i} onClick={onSelect(option)}>
            {renderItem(option)}
          </StyledDropdownItem>
        ))}
      </StyledDropdownListContainer>
    );
  }
);

const StyledDropdownItem = styled.li`
  padding: 0.5rem;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 5px;
  &:hover {
    background-color: ${(props) => props.theme.colors.hoverBg};
  }
`;

//Dropdown Item with main info and secondary info
export function ExtraInfoDropdownItem({ option }) {
  return (
    <>
      <div className="font-weight-bold">{option.main}</div>
      <div>{option.info}</div>
    </>
  );
}
